import classNames from "classnames";
import React from "react";
import { PlaceholderImage } from "../../../placeholder";

import "./photo-selection-photo.css";
import { useStableCallback } from "../../../../hooks/useStableCallback";

interface IPhotoSelectionPanelItem {
	id: string;
	url: string;
	width: number;
	height: number;
	angle: eXpress.core.Rotate90;
	title?: string;
	isRejected?: boolean;

	// later:
	// rotation: Do we need to rotate depending on exif information or is rotation included in when using a data-url?
}

export function PhotoSelectionPhoto({
	className,
	item,
	isDragging,
	onKeyPress,
	...gestureHandlers
}: {
	className?: string;
	isDragging?: boolean | undefined;
	item: IPhotoSelectionPanelItem;
	onKeyPress?: (event: React.KeyboardEvent) => void;
} & { [key: string]: unknown }) {
	const { id, width, height, title, url, isRejected } = item;

	const styles = classNames([
		{
			"photo-selection-photo--rejected": isRejected,
		},
		className,
	]);

	const isClickable = !!gestureHandlers["onClick"];

	// Make clickable by keyboard
	const onKeyDown = useStableCallback((event: React.KeyboardEvent) => {
		if (onKeyPress && (event.key === "Enter" || event.key === " ")) {
			onKeyPress(event);
		}
	});

	// Set cursor style
	let cursor: React.CSSProperties["cursor"] = isClickable ? "pointer" : undefined;
	if (isDragging) cursor = "grabbing";
	else if (isDragging === false) cursor = "grab";

	return (
		<div className={styles}>
			<PlaceholderImage
				className="photo-selection-photo__img"
				style={{
					aspectRatio:
						item.angle % 180 === 0 ? `${width} / ${height}` : `${height} / ${width}`,
					cursor,
				}}
				src={url}
				alt={title || id}
				title={title}
				loading="lazy"
				role={isClickable ? "button" : undefined}
				tabIndex={isClickable ? 0 : undefined}
				{...gestureHandlers}
				onKeyDown={onKeyDown}
			/>
		</div>
	);
}
